import { createContext } from "react";

export const tokenContext = createContext(null);